import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

interface ComicCardProps {
  comic: Comic;
  size?: "small" | "medium" | "large";
}

export default function ComicCard({ comic, size = "medium" }: ComicCardProps) {
  const coverH =
    size === "large" ? "h-72" : size === "small" ? "h-48" : "h-60";
  const titleSize =
    size === "large" ? "text-base" : size === "small" ? "text-xs" : "text-sm";

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block w-full cursor-pointer"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    >
      <div
        className={`relative ${coverH} w-full overflow-hidden rounded-lg bg-background-200`}
      >
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 韩漫在线免费阅读`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        {comic.status === "已完结" && (
          <span className="absolute top-2 left-2 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-semibold text-background-50">
            已完结
          </span>
        )}
        {comic.status === "连载中" && (
          <span className="absolute top-2 left-2 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-semibold text-background-50">
            连载
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-xs text-foreground-400 line-clamp-2 leading-relaxed">
            {comic.description.slice(0, 60)}...
          </p>
        </div>
      </div>
      <div className="mt-2.5">
        <h3
          className={`${titleSize} font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200`}
        >
          {comic.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-600 line-clamp-1">
          {comic.author}
        </p>
        {size !== "small" && (
          <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
            <span className="flex items-center gap-0.5">
              <i className="ri-star-fill text-primary-500 text-xs"></i>
              {comic.rating}
            </span>
            <span>
              {(comic.views / 10000).toFixed(1)}万
            </span>
          </div>
        )}
      </div>
    </Link>
  );
}